import React from "react";
import "./ImageOval.css";

interface ImageOvalProps {
  images: string[];
  direction?: "left" | "right";
}

const ImageOval: React.FC<ImageOvalProps> = ({ images, direction = "left" }) => {
  return (
    <div className={`oval-gallery ${direction}`}>
      <div className="oval-track">
        {images.concat(images).map((src, i) => (
          <div key={i} className="oval-image">
            <img src={src} alt={`luxury-${i}`} loading="lazy" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageOval;
